// extracted by mini-css-extract-plugin
export default {"root":"vbQVfeEkpXwihzvyowNY","item":"I5G5OBKa6LwIQSqBMo4Y","hasMatch":"pnTiwrid64hIbunwRbbD","draggedOver":"e_CnMeBSmyZHCxaYI5z1","table":"qa6hUXG4G2f90aKyz6wC"};